import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import axios from "axios";
//import { logout } from "../../../redux/authSlice"; // Assuming logout action clears state

import { logout } from "../redux/authSlice";

const Logout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const logoutStarted = useRef(false);

  useEffect(() => {
    if (logoutStarted.current) return;
    logoutStarted.current = true;

    const handleLogout = async () => {
      try {
        const userString = localStorage.getItem("person");

        if (!userString) {
          dispatch(logout()); // Clear Redux state
          navigate("/"); // Navigate to the homepage
          return;
        }

        const user = JSON.parse(userString);
        if (!user?.token) {
          dispatch(logout()); // Clear Redux state
          navigate("/"); 

          return;
        }

        const response = await axios.post(
          `${process.env.REACT_APP_URL}/auth/logout2`,
          {},
          {
            headers: {
              Authorization: `Bearer ${user.token}`,
              "Content-Type": "application/json",
              "X-React-Route":'/logout',
            },
            withCredentials: true,
          }
        );


        sessionStorage.removeItem("person"); // Clear session storage
        dispatch(logout()); // Dispatch Redux logout action
        navigate("/"); // Navigate to the homepage
      } catch (error) {
        console.error("Logout failed:", error);
        // If there's an error, at least clear session storage and navigate to home
        sessionStorage.removeItem("person"); // Clear session storage
        dispatch(logout()); // Dispatch Redux logout action
        navigate("/"); // Navigate to homepage even on error
      }
    };

    handleLogout();
  }, [dispatch, navigate]);

  return null; // You can add a loading message or just return null during the logout process
};

export default Logout;
